var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-group" },
    [
      _vm._t("label", function () {
        return [
          _vm.label
            ? _c("label", { class: _vm.labelClasses }, [
                _vm._v("\n      " + _vm._s(_vm.label) + "\n    "),
              ])
            : _vm._e(),
        ]
      }),
      _c(
        "div",
        {
          class: [
            { "input-group": _vm.hasIcon },
            { focused: _vm.focused },
            { "input-group-alternative": _vm.alternative },
            { "has-label": _vm.label || _vm.$slots.label },
            _vm.inputGroupClasses,
          ],
        },
        [
          _vm.prependIcon || _vm.$slots.prepend
            ? _c("div", { staticClass: "input-group-prepend" }, [
                _c(
                  "span",
                  { staticClass: "input-group-text" },
                  [
                    _vm._t("prepend", function () {
                      return [_c("i", { class: _vm.prependIcon })]
                    }),
                  ],
                  2
                ),
              ])
            : _vm._e(),
          _vm._t(
            "default",
            function () {
              return [
                _c(
                  "input",
                  _vm._g(
                    _vm._b(
                      {
                        staticClass: "form-control",
                        class: [
                          { "is-valid": _vm.valid === true },
                          { "is-invalid": _vm.error },
                          _vm.inputClasses,
                        ],
                        attrs: {
                          type: _vm.type,
                          valid: !_vm.error,
                          required: _vm.required,
                        },
                        domProps: { value: _vm.value },
                      },
                      "input",
                      _vm.$attrs,
                      false
                    ),
                    _vm.listeners
                  )
                ),
              ]
            },
            null,
            _vm.slotData
          ),
          _vm.appendIcon || _vm.$slots.append
            ? _c("div", { staticClass: "input-group-append" }, [
                _c(
                  "span",
                  { staticClass: "input-group-text" },
                  [
                    _vm._t("append", function () {
                      return [_c("i", { class: _vm.appendIcon })]
                    }),
                  ],
                  2
                ),
              ])
            : _vm._e(),
          _vm._t("infoBlock"),
          _vm._t("error", function () {
            return [
              _vm.error
                ? _c(
                    "div",
                    {
                      staticClass: "invalid-feedback",
                      staticStyle: { display: "block" },
                    },
                    [_vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]
                  )
                : _vm._e(),
            ]
          }),
          _vm._t("success", function () {
            return [
              !_vm.error && _vm.valid
                ? _c("div", { staticClass: "valid-feedback" }, [
                    _vm._v(
                      "\n        " + _vm._s(_vm.successMessage) + "\n      "
                    ),
                  ])
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }